import { render, staticRenderFns } from "./LeavesDialog.vue?vue&type=template&id=9805546e&scoped=true"
import script from "./LeavesDialog.vue?vue&type=script&lang=js"
export * from "./LeavesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9805546e",
  null
  
)

export default component.exports